/****************************************************************
 * jotai state and atoms for the accounts listing
 ***************************************************************/

import { atom, useSetAtom } from 'jotai';
import { atomWithReset, atomWithStorage, useResetAtom } from 'jotai/utils';
import callApi from 'lib/callApi';
import { companyIdAtom } from 'views/state';

import { DEFAULT_PAGE_SIZE } from '../types';
export const DEFAULT_ACCOUNT_LISTING_COLUMNS = [
  'account',
  'repositories',
  'user',
  'owner_name',
  'updated_at',
  'actions',
];
export const enabledColumnKeysAtom = atomWithStorage(
  'sast_account_enabled_column_keys',
  DEFAULT_ACCOUNT_LISTING_COLUMNS,
);
export const forceReloadAccountsAtom = atom<string>('');

/**
 * This will not trigger an API Call, just rerender the UI
 */
export const forceRerenderUIAtom = atom<string>('');

export const selectedRowIdsAtom = atom<number[]>([]);
export const paginationConfigAtom = atomWithReset({
  page_size: DEFAULT_PAGE_SIZE,
  page: 1,
});
export const orderbyAtom = atomWithReset<string>('updated_at');
export const sortOrderAtom = atomWithReset<'desc' | 'asc'>('desc');

export const accountDataAtom = atom(async (get) => {
  const companyId = get(companyIdAtom);
  const paginationConfig = get(paginationConfigAtom);

  const orderBy = get(orderbyAtom);
  const sortOrder = get(sortOrderAtom);
  const ordering = `${sortOrder === 'desc' ? '-' : ''}${orderBy}`;

  try {
    if (companyId && companyId !== -1) {
      const params = {
        company_id: companyId,
        page: paginationConfig.page, // Specify the page number you want to retrieve
        page_size: paginationConfig.page_size, // Specify the number of items per page
        ordering: ordering, // Specify the field to sort by and the sorting order
      };

      const responseData = await callApi('sast/accounts/', 'GET', params);
      return responseData?.data;
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
  return undefined;
});

/**
 * reset the repository page state
 */
export function useAccountsResetAtoms() {
  const resetPaginationConfigAtom = useResetAtom(paginationConfigAtom);
  const resetOrderbyAtom = useResetAtom(orderbyAtom);
  const resetOrderAtom = useResetAtom(sortOrderAtom);
  const setForceRefresh = useSetAtom(forceReloadAccountsAtom);
  const resetAtoms = () => {
    resetPaginationConfigAtom();
    resetOrderbyAtom();
    resetOrderAtom();
    setForceRefresh(Math.random().toString());
  };

  return resetAtoms;
}
